import styled from 'styled-components';

export const SettingsTooltipStyled = styled.div`
  .hide {
    display: none;
  }
  display: flex;
  flex-direction: column;
  width: 100%;
  font-size: 0.8rem;
  border-radius: 5px;
  border: 1px solid ${props => props.theme.grayUltraUltraLight};
  box-shadow: 2px 5px 15px -6px ${props => props.theme.textColor};

  label {
    font-size: 0.8rem;
  }

  .settingsTooltip {
    &__header {
      width: 100%;
      background: ${props => props.theme.textColor};
      color: ${props => props.theme.bgColor};
      padding: 0.25rem 0;
      line-height: 25px;

      &--empty {
        padding: 0.25rem 0.25rem;
      }
    }

    &__properties {
      display: flex;
      width: 100%;
      flex-direction: column;
      background-color: ${props => props.theme.bgColor};
      color: ${props => props.theme.textColor};
      border-bottom: 1px solid ${props => props.theme.grayUltraUltraLight};
      &.hide {
        display: none;
      }

      .checkboxContainer {
        line-height: 25px;
        display: flex
      }


      label:not(.switchLabel) {
        align-self: center;
        padding: 0 0.65rem;
      }

      select {
        align-self: center;
        width: 100px;
        padding: 0.15rem 0.5rem;
        height: 30px;
      }
    }

    &__thereshold {
      &Selector {
        padding: 0.25rem 0.5rem;
        width: 100px;
        height: 30px;
        margin-top: 5px;
      }
    }

    &__timeFrame,
    &__timeFrameUnits,
    &__timeFrameValue {
      display: flex;
      flex-direction: row;
      line-height: 35px;

      &.hide {
        display: none;
      }

      .checkboxContainer {
        line-height: 25px;
        display: flex
      }


      label:not(.switchLabel) {
        align-self: center;
        padding: 0 0.65rem;
      }

      select {
        align-self: center;
        width: 100px;
        padding: 0.15rem 0.5rem;
        height: 30px;
      }
    }

    &__timeFrameUnits,
    &__timeFrameValue {
      border-top: 1px solid ${props => props.theme.grayUltraUltraLight};
    }
  }
`;
